export default function Title(props) {
  const { Tag, text, highlighted } = props;

  return (
    <Tag className="h1 text-light leading-none max-w-6xl mx-auto text-center">
      <span className="relative z-20 block">{text}</span>

      <span className="-mt-4 md:-mt-8 w-fit mx-auto text-secondary title-border leading-none lg:-ml-8">
        <span className="title-bg-wrapper">
          <span className="title-shape"></span>
        </span>
        <span className="relative z-10 ">{highlighted}</span>
      </span>
    </Tag>
  );
}
